import { emptyProgress, type Progress } from './api';

const KEY = 'iprep_demo_progress';
const NOTES_KEY = 'iprep_demo_notes';

function today() {
  const date = new Date();
  const offset = date.getTimezoneOffset() * 60_000;
  return new Date(date.getTime() - offset).toISOString().slice(0, 10);
}

export function loadDemoProgress(): Progress {
  try {
    return { ...emptyProgress(), ...JSON.parse(localStorage.getItem(KEY) || '{}') };
  } catch {
    return emptyProgress();
  }
}

function withStats(progress: Progress): Progress {
  const completedDays = Object.values(progress.days).filter((day) => day.status === 'completed').length;
  const dates = [...new Set(progress.activity)].sort().reverse();
  let streak = 0;
  const cursor = new Date(`${today()}T12:00:00`);
  if (dates[0] && dates[0] !== today()) cursor.setDate(cursor.getDate() - 1);
  while (dates.includes(cursor.toISOString().slice(0, 10))) {
    streak += 1;
    cursor.setDate(cursor.getDate() - 1);
  }
  const xp = completedDays * 100;
  const longestStreak = Math.max(progress.stats.longestStreak, streak);
  const badges = [
    completedDays >= 1 && 'first-step', streak >= 7 && 'week-warrior', completedDays >= 18 && 'dsa-foundations',
    completedDays >= 38 && 'algorithm-architect', completedDays >= 56 && 'systems-thinker', completedDays >= 60 && 'interview-ready',
  ].filter(Boolean) as string[];
  return {
    ...progress,
    activity: dates,
    badges,
    stats: { currentStreak: streak, longestStreak, lastActiveDate: dates[0] || null, xp, level: Math.floor(xp / 500) + 1, completedDays },
  };
}

function save(progress: Progress) {
  const next = withStats(progress);
  localStorage.setItem(KEY, JSON.stringify(next));
  return next;
}

export function demoToggle(progress: Progress, day: number, taskId: string, done: boolean) {
  return save({ ...progress, tasks: { ...progress.tasks, [`${day}:${taskId}`]: done }, activity: done ? [...progress.activity, today()] : progress.activity });
}

export function demoComplete(progress: Progress, day: number) {
  return save({
    ...progress,
    days: { ...progress.days, [day]: { status: 'completed', completedAt: new Date().toISOString() } },
    activity: [...progress.activity, today()],
  });
}

export function demoNote(day: number) {
  const notes = JSON.parse(localStorage.getItem(NOTES_KEY) || '{}');
  return notes[day] || '';
}

export function saveDemoNote(day: number, body: string) {
  const notes = JSON.parse(localStorage.getItem(NOTES_KEY) || '{}');
  notes[day] = body;
  localStorage.setItem(NOTES_KEY, JSON.stringify(notes));
}

